import { HttpClient, HttpContext } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { SHOW_MODAL_ON_ERROR } from 'projects/suche-lib/src/lib/interceptors/interceptor.token';
import { SucheError } from 'projects/suche-lib/src/lib/services/integration/suche-error';
import { LoggingService } from 'projects/suche-lib/src/lib/services/logging.service';
import { LIB_CONFIG, LibConfig } from 'projects/suche-lib/src/projects';
import { catchError } from 'rxjs';
import { Version } from '../../model/version';

@Component({
  selector: 'now-wbsuche-app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly http = inject(HttpClient);
  private readonly logger = inject(LoggingService);
  private readonly metaService = inject(Meta);
  private readonly changeDetection = inject(ChangeDetectorRef);

  public versionCommit?: string;
  public kursnetDatenstandDatum?: string;

  ngOnInit(): void {
    this.http
      .get<Version>(`${this.libConfig.backendHost}/pc/v1/version`, {
        responseType: 'json',
        context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
      })
      .pipe(
        catchError((error) => {
          throw new SucheError('Fehler beim Laden der Version', error);
        })
      )
      .subscribe({
        next: (resp) => {
          const regex = /(?<=\.)\d{6}/;
          const match = resp.serverVersion?.match(regex);
          if (match) {
            const date = match[0];
            const dateParts = date.match(/.{1,2}/g)!;
            const day = dateParts[2];
            const month = dateParts[1];
            const year = dateParts[0];
            this.metaService.updateTag({
              name: 'dcterms.modified',
              content: `20${year}-${month}-${day}`
            });
          }
          this.versionCommit = resp.serverVersion;
          this.kursnetDatenstandDatum = resp.kursnetDatenstandDatum;
          this.changeDetection.detectChanges();
        },
        error: (error) => {
          this.logger.error(error);
          this.versionCommit = '';
          this.kursnetDatenstandDatum = '';
          this.changeDetection.detectChanges();
        }
      });
  }
}
